import React, { useState, useEffect } from 'react';
import { Link, useParams, useNavigate } from 'react-router-dom';

function ResetPassword() {
    const { token } = useParams();
    const navigate = useNavigate();

    const [password, setPassword] = useState('');
    const [confirmPassword, setConfirmPassword] = useState('');
    const [loading, setLoading] = useState(false);
    const [verifying, setVerifying] = useState(true);
    const [success, setSuccess] = useState(false);
    const [error, setError] = useState('');
    const [tokenError, setTokenError] = useState('');
    const [firstName, setFirstName] = useState('');

    useEffect(() => {
        // Verify token on mount
        const verifyToken = async () => {
            try {
                const res = await fetch(`/api/auth/verify-reset-token/${token}`);
                const data = await res.json();

                if (!res.ok) {
                    setTokenError(data.error || 'Ungueltiger Link');
                } else {
                    setFirstName(data.data?.first_name || '');
                }
            } catch (err) {
                setTokenError('Ein Fehler ist aufgetreten');
            }
            setVerifying(false);
        };

        verifyToken();
    }, [token]);

    const handleSubmit = async (e) => {
        e.preventDefault();
        setError('');

        if (password !== confirmPassword) {
            setError('Die Passwoerter stimmen nicht ueberein');
            return;
        }

        if (password.length < 6) {
            setError('Das Passwort muss mindestens 6 Zeichen haben');
            return;
        }

        setLoading(true);

        try {
            const res = await fetch('/api/auth/reset-password', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ token, new_password: password })
            });

            const data = await res.json();

            if (!res.ok) {
                throw new Error(data.error || 'Ein Fehler ist aufgetreten');
            }

            setSuccess(true);
        } catch (err) {
            setError(err.message);
        }
        setLoading(false);
    };

    if (verifying) {
        return (
            <div className="row justify-content-center">
                <div className="col-md-6 col-lg-4">
                    <div className="card mt-5">
                        <div className="card-body text-center p-5">
                            <div className="spinner-border text-primary mb-3" role="status">
                                <span className="visually-hidden">Laden...</span>
                            </div>
                            <p className="text-muted">Link wird ueberprueft...</p>
                        </div>
                    </div>
                </div>
            </div>
        );
    }

    if (tokenError) {
        return (
            <div className="row justify-content-center">
                <div className="col-md-6 col-lg-4">
                    <div className="card mt-5">
                        <div className="card-body text-center p-5">
                            <div style={{ fontSize: '4rem', marginBottom: '1rem' }}>❌</div>
                            <h4 className="card-title mb-3">Link ungueltig</h4>
                            <p className="text-muted mb-4">
                                {tokenError}
                            </p>
                            <p className="text-muted small mb-4">
                                Der Link ist moeglicherweise abgelaufen oder wurde bereits verwendet.
                            </p>
                            <Link to="/passwort-vergessen" className="btn btn-primary">
                                Neuen Link anfordern
                            </Link>
                        </div>
                    </div>
                </div>
            </div>
        );
    }

    if (success) {
        return (
            <div className="row justify-content-center">
                <div className="col-md-6 col-lg-4">
                    <div className="card mt-5">
                        <div className="card-body text-center p-5">
                            <div style={{ fontSize: '4rem', marginBottom: '1rem' }}>✅</div>
                            <h4 className="card-title mb-3">Passwort geaendert!</h4>
                            <p className="text-muted mb-4">
                                Dein Passwort wurde erfolgreich geaendert. Du kannst dich jetzt mit deinem neuen Passwort anmelden.
                            </p>
                            <Link to="/login" className="btn btn-primary">
                                Zum Login
                            </Link>
                        </div>
                    </div>
                </div>
            </div>
        );
    }

    return (
        <div className="row justify-content-center">
            <div className="col-md-6 col-lg-4">
                <div className="card mt-5">
                    <div className="card-body">
                        <h4 className="card-title mb-4">Neues Passwort erstellen</h4>
                        {firstName && (
                            <p className="text-muted mb-4">
                                Hallo {firstName}, gib dein neues Passwort ein.
                            </p>
                        )}

                        {error && (
                            <div className="alert alert-danger">{error}</div>
                        )}

                        <form onSubmit={handleSubmit}>
                            <div className="mb-3">
                                <label className="form-label">Neues Passwort</label>
                                <input
                                    type="password"
                                    className="form-control"
                                    value={password}
                                    onChange={(e) => setPassword(e.target.value)}
                                    required
                                    autoFocus
                                    minLength={6}
                                    placeholder="Mindestens 6 Zeichen"
                                />
                            </div>
                            <div className="mb-3">
                                <label className="form-label">Passwort bestaetigen</label>
                                <input
                                    type="password"
                                    className="form-control"
                                    value={confirmPassword}
                                    onChange={(e) => setConfirmPassword(e.target.value)}
                                    required
                                    minLength={6}
                                    placeholder="Passwort wiederholen"
                                />
                            </div>
                            <button
                                type="submit"
                                className="btn btn-primary w-100"
                                disabled={loading}
                            >
                                {loading ? (
                                    <>
                                        <span className="spinner-border spinner-border-sm me-2"></span>
                                        Speichern...
                                    </>
                                ) : (
                                    'Passwort speichern'
                                )}
                            </button>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default ResetPassword;
